import AssetCard from '../../modules/AssetCard';
import { useModalContext } from '@/presentation/context/modal';
import { Asset } from 'nftx.js';
import useVault from '@/application/read/vaults/useVault';

export interface AuctionsProps extends Asset {}

export const AuctionContainer = ({
  assetAddress,
  imageUrl,
  tokenId,
  dateAdded,
  vaultIds: [vaultId],
  quantity,
}: AuctionsProps) => {
  const { showSwapModal } = useModalContext();
  const { data: vault } = useVault({ vaultId });

  return (
    <AssetCard
      assetAddress={assetAddress}
      tokenId={tokenId}
      imageUrl={imageUrl}
      dateAdded={dateAdded}
      is1155={!!vault?.is1155}
      selectedQuantity={1}
      onQuantityChange={() => void 0}
      onClick={() =>
        showSwapModal({
          buyType: 'NFT',
          buyVaultAddress: vault?.id,
          buyVaultId: vaultId,
          buyTokenIds: [tokenId],
          canFlip: false,
          // showSell: false,
          canChangeSellToken: false,
          canChangeBuyToken: false,
          sellType: 'ETH',
        })
      }
      quantity={quantity}
      vaultId={vaultId}
    />
  );
};

export default AuctionContainer;
